exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_list_pQWprmcHZYefQKVx9L0Oj {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  background-position: center;\n  background-size: cover;\n}\n\n.IA_headline_3xmQrAQLHO-AO8u3ISXrEn {\n  width: 100%;\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_list": "IA_list_pQWprmcHZYefQKVx9L0Oj",
	"IA_headline": "IA_headline_3xmQrAQLHO-AO8u3ISXrEn"
};